module.exports = __webpack_public_path__ + "img/no-audio.29a52e9a.svg";